<template>
    <section
        id="how-it-works"
        class="how-it-works band-cream"
    >
        <div class="section-head">
            <span class="kicker">{{ copy.kicker }}</span>
            <h2>{{ copy.title }}</h2>
        </div>
        <ol class="steps">
            <li
                v-for="(step, index) in copy.steps"
                v-bind:key="index"
                class="step"
                data-aos="fade-up"
                :data-aos-delay="index * 120"
            >
                <span class="step__number ff-display">0{{ index + 1 }}</span>
                <svg
                    class="step__icon"
                    viewBox="0 0 24 24"
                    width="30"
                    height="30"
                    aria-hidden="true"
                >
                    <path
                        :d="icons[index]"
                        fill="currentColor"
                    />
                </svg>
                <h3 class="step__title">{{ step.title }}</h3>
                <p class="step__text">{{ step.text }}</p>
            </li>
        </ol>
    </section>
</template>

<script>
import { mapState } from 'pinia'
import { useStore } from '@/stores/index'
import { getHomeContent } from '@/data/home'

// Material icon paths: edit, group, favorite.
const ICONS = [
    'M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z',
    'M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z',
    'M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z',
]

export default {
    name: 'HowItWorksSection',
    data() {
        return { icons: ICONS }
    },
    computed: {
        ...mapState(useStore, ['language']),
        copy() {
            return getHomeContent(this.language).howItWorks
        },
    },
}
</script>

<style lang="scss" scoped>
.how-it-works {
    scroll-margin-top: $header-height;
}

.steps {
    list-style: none;
    margin: 0 auto;
    padding: 0;
    max-width: 1040px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 20px;
}

.step {
    position: relative;
    padding: 28px 26px 30px;
    border-radius: 20px;
    background: var(--bzioup-bg-color-A);
    border: 1px solid rgba(0, 0, 0, 0.05);
    box-shadow: var(--bzioup-shadow-soft);
    text-align: left;
    transition: transform 220ms cubic-bezier(0.2, 0.8, 0.3, 1), box-shadow 220ms ease;
}

.step:hover {
    transform: translateY(-4px);
    box-shadow: 0 16px 36px rgba(8, 20, 72, 0.1);
}

.step__number {
    position: absolute;
    top: 18px;
    right: 22px;
    font-size: 44px;
    line-height: 1;
    color: var(--bzioup-color-pink);
    opacity: 0.25;
}

.step__icon {
    display: block;
    color: var(--bzioup-color-pink);
    margin-bottom: 18px;
}

.step__title {
    margin: 0 0 10px;
    font-size: 20px;
    font-weight: 700;
}

.step__text {
    margin: 0;
    font-size: 15px;
    line-height: 1.55;
    color: var(--bzioup-color-Y);
}
</style>
